import React, { useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { KeyboardShortcutsProvider } from './contexts/KeyboardShortcutsContext';
import { AccessibilityProvider } from './components/accessibility/AccessibilityProvider';
import { ToastProvider } from './contexts/ToastContext.jsx';
import ErrorBoundary from './components/ErrorBoundary';
import ThemeCustomizer from './components/ThemeCustomizer';
import appInitService from './utils/appInitService.js';
import './styles/accessibility.css';


function App() {
  // Initialize application services
  useEffect(() => {
    console.log('🚀 App component mounted, initializing services...');

    const initializeApp = async () => {
      try {
        await appInitService.initialize();
        console.log('✅ App services initialized successfully');
      } catch (error) {
        console.error('❌ Failed to initialize app services:', error);
      }
    };

    initializeApp();

    // Cleanup on unmount
    return () => {
      console.log('🧹 App component unmounting, cleaning up services...');
      appInitService.cleanup();
    };
  }, []);

  return (
    <ErrorBoundary>
      <DndProvider backend={HTML5Backend}>
        <BrowserRouter>
          <ThemeProvider>
            <ToastProvider>
              <AccessibilityProvider>
              <AuthProvider>
                <ProjectProvider>
                  <KeyboardShortcutsProvider>
                    <div className='w-full aurora-container'>
                      {/* Global Aurora Background Blobs */}
                      <div className="aurora-blob top-0 -left-64 w-[600px] h-[600px] bg-blue-400/10 dark:bg-blue-900/10"></div>
                      <div className="aurora-blob bottom-0 -right-64 w-[600px] h-[600px] bg-purple-400/10 dark:bg-purple-900/10"></div>
                      
                      <ThemeCustomizer />
                      
                      <div className="relative z-10 w-full">
                        <Routes />
                      </div>
                    </div>
                  </KeyboardShortcutsProvider>
                </ProjectProvider>
              </AuthProvider>
            </AccessibilityProvider>
            </ToastProvider>
          </ThemeProvider>
        </BrowserRouter>
      </DndProvider>
    </ErrorBoundary>
  );
}

export default App;
